/* eslint-disable import/prefer-default-export */
/* eslint-disable no-console */
const bundleOptions = document.querySelectorAll('.bundle-option');

function removeSelected(el) {
  el.forEach((bundle) => {
    const btn = bundle.querySelector('.bundle-select');
    if (bundle.classList.contains('selected')) {
      bundle.classList.remove('selected');
      btn.textContent = 'select';
    }
  });
}

function updateBundleFormValue(value) {
  const hiddenField = document.querySelector('input[data-mailchimp="SELECTED_BUNDLE"]');
  // console.log(hiddenField);
  hiddenField.value = value.replace('_', ' ');
}

function bundleSelector() {
  bundleOptions.forEach((bundle) => {
    // console.log(bundle);
    const btn = bundle.querySelector('.bundle-select');
    let option;
    // console.log(option);
    btn.addEventListener('click', () => {
      // if the bundle isn't already selected, remove other selctions and add selected to this one
      if (!bundle.classList.contains('selected')) {
        // remove .selected class from other bundles
        removeSelected(bundleOptions);
        // add .selected to this bundle
        bundle.classList.toggle('selected');
        // change text to deselect
        btn.textContent = 'deselect';
        option = bundle.id;
      } else {
        // if the bundle is already selected when clicked on, toggle off the .selected class
        bundle.classList.toggle('selected');
        btn.textContent = 'select';
        option = '';
      }
      // pass the selected value to the form
      updateBundleFormValue(option);
    });
  });
}

export {
  bundleSelector,
};

/* eslint-enable no-console */
/* eslint-enable import/prefer-default-export */
